import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { capitalizeFirstChar } from '../../shared/util/assessments';
import { Dehydration } from '../questions/dehydration/Dehydration';
import { IconSelect } from '../questions/iconSelect/IconSelect';
import { NumberSelectQuestion } from '../questions/numberSelectQuestion/NumberSelectQuestion';
import { AssessmentPageItem } from '../types/AssessmentPageItem';

export function Hydration1({
  active,
  assessmentValues,
  questionid,
  questionHeading,
  questionText,
  onOpenModal,
  onSetValue,
}: AssessmentPageItem) {
  const { t } = useTranslation();
  const [showSQ, setShowSQ] = useState(false);

  const { caffeine } = assessmentValues;

  useEffect(() => {
    if (caffeine && Number(caffeine) > 0) {
      setShowSQ(true);
    } else {
      setShowSQ(false);
      onSetValue({ id: 'caffeine_hours_before_bed', value: null });
    }
  }, [caffeine]);

  return (
    <div className={`question_container ${active}`} id={questionid}>
      <h1>{questionHeading}</h1>
      <p>{questionText}</p>

      <IconSelect
        questionid="hydration"
        range="11"
        questionTitle={t('assessment.question.hydration')}
        width=""
        onSetValue={onSetValue}
        assessmentValues={assessmentValues}
        modalText={t('HD002')}
        onOpenModal={onOpenModal}
        labelText={t('A143')}
      />
      <Dehydration
        questionid="dehydration"
        questionTitle={t('assessment.question.dehydration')}
        width=""
        onSetValue={onSetValue}
        assessmentValues={assessmentValues}
        modalText={t('HD004')}
        onOpenModal={onOpenModal}
      />
      <IconSelect
        questionid="caffeine"
        range="6"
        questionTitle={t('assessment.question.caffeine')}
        width=" spaced"
        onSetValue={onSetValue}
        assessmentValues={assessmentValues}
        modalText={t('HD006')}
        onOpenModal={onOpenModal}
        labelText={t('A144')}
      />
      {showSQ && (
        <NumberSelectQuestion
          questionid="caffeine_hours_before_bed"
          questionTitle={t('assessment.question.caffeine_hours_before_bed')}
          minlimit={0}
          maxlimit={20}
          width=""
          onSetValue={onSetValue}
          assessmentValues={assessmentValues}
          skippable
          controlsInfo={t('A140')}
          labelText={capitalizeFirstChar(t('HD008'))}
        />
      )}
    </div>
  );
}
